import moment from 'moment';
const USER_KEY = 'lluser';
const BANNERS_KEY = 'sh_banners';
const REDIRECT_URL_KEY = 'redirect_url_key';

const BANNERS_VALID_TIME_KEY = 'banners_valid_date';

const REDIRECT_URL_VALID_TIME_KEY = 'redirect_url_valid_date';


const WEIXINLOGINDATA = 'wx_login_data';
const WEIXINLOGINDATA_VALID_TIME_KEY = 'wx_login_data_valid_date';


const DATE_FORMAT = 'YYYY-MM-DD HH:mm:sss';

const LOGINVALIDDATE = 'shl_login_valid_date';

const WECHATBASEAUTHOCODE = 'shl_wechat_base_code';

const WECHATBASECODEVALID = 'shl_wechat_base_code_valid_date';

const PHONEVALIDDATE = 'shl_phone_valid_date';

const PHONEVERIFYCODEKEY = 'shl_phone_verify_code_key';

export default {
  set(key, value) {
    localStorage.setItem(key, value);
  },
  remove(key) {
    localStorage.removeItem(key);
  },
  update(key, value) {
    this.set(key, value);
  },
  setUser(user) {
    let key = USER_KEY;
    if (user == null || user == undefined) {
      this.remove(key);
      return;
    }

    let temp = JSON.stringify(user);
    this.set(key, temp);
  },
  getUser() {
    let key = USER_KEY;
    let temp = this.get(key);
    if (temp == null) {
      return temp;
    }
    temp = JSON.parse(temp);
    return temp;
  },
  clearUser() {
    this.setUser(null);
  },

  setBanners(banners) {
    let key = BANNERS_KEY;
    if (banners == null || banners == undefined) {
      this.remove(key);
      this.remove(BANNERS_VALID_TIME_KEY);
      return;
    }

    let now = moment().format(DATE_FORMAT);
    this.set(BANNERS_VALID_TIME_KEY, now);
    let temp = JSON.stringify(banners);
    this.set(key, temp);
  },

  getBanners() {
    let key = BANNERS_KEY;
    let temp = this.get(key);
    if (temp == null) {
      return temp;
    }

    let validDateStr = this.get(BANNERS_VALID_TIME_KEY);
    let bannerDate = moment(validDateStr, DATE_FORMAT);
    if (bannerDate.isValid()) {
      let now = moment();
      let interval = now - bannerDate;
      if (interval < 30 * 60 * 1000) {
        temp = JSON.parse(temp);
        return temp;
      }
    }
    return null;
  },

  get(key) {
    let value = localStorage.getItem(key);
    return value;
  },
  getToken() {
    let user = this.getUser();
    if (user == null) {
      return null;
    }

    let token = user.token;
    return token;
  },

  setRedirectUrl(url) {
    let key = REDIRECT_URL_KEY;
    if (url == null || url == undefined || url.length == 0) {
      this.remove(key);
      this.remove(REDIRECT_URL_VALID_TIME_KEY);
      return;
    }

    let now = moment().format(DATE_FORMAT);
    this.set(REDIRECT_URL_VALID_TIME_KEY, now);
    let temp = JSON.stringify(url);
    this.set(key, temp);
  },
  getRedirectUrl() {
    let key = REDIRECT_URL_KEY;
    let temp = this.get(key);
    if (temp == null) {
      return temp;
    }

    let validDateStr = this.get(REDIRECT_URL_VALID_TIME_KEY);
    let redirectUrlDate = moment(validDateStr, DATE_FORMAT);
    if (redirectUrlDate.isValid()) {
      let now = moment();
      let interval = now - redirectUrlDate;
      if (interval < 5 * 60 * 1000) {
        temp = JSON.parse(temp);
        return temp;
      }
    }
    return null;
  },

  setWeixinData(obj) {
    let key = WEIXINLOGINDATA;
    let timeKey = WEIXINLOGINDATA_VALID_TIME_KEY;
    if (obj == null || obj == undefined) {
      this.remove(key);
      this.remove(timeKey);
      return;
    }

    let now = moment().format(DATE_FORMAT);
    this.set(timeKey, now);
    let temp = JSON.stringify(obj);
    this.set(key, temp);
  },
  getWeixinData() {
    let key = WEIXINLOGINDATA;
    let timeKey = WEIXINLOGINDATA_VALID_TIME_KEY;

    let temp = this.get(key);
    if (temp == null) {
      return temp;
    }

    let validDateStr = this.get(timeKey);
    let redirectUrlDate = moment(validDateStr, DATE_FORMAT);
    if (redirectUrlDate.isValid()) {
      let now = moment();
      let interval = now - redirectUrlDate;
      if (interval < 10 * 60 * 1000) {
        temp = JSON.parse(temp);
        return temp;
      }
    }
    return null;
  },

  setLoginDate() {
    let key = LOGINVALIDDATE;
    let now = moment();
    let dateStr = now.format(DATE_FORMAT);
    this.set(key, dateStr);
  },

  getLoginDate() {
    let key = LOGINVALIDDATE;
    let dateStr = this.get(key);
    if (dateStr == null) {
      return null;
    } else {
      return moment(dateStr, DATE_FORMAT);
    }
  },

  showLoginDialog() {
    let loginDate = this.getLoginDate();
    if (loginDate == null) {
      this.setLoginDate();
      return true;
    }
    let storeDateStr = loginDate.format('YYYY-MM-DD');
    let now = moment();
    let nowStr = now.format('YYYY-MM-DD');

    if (nowStr == storeDateStr) {
      return false;
    } else {
      this.setLoginDate();
      return true;
    }
  },


  setPhoneVerifyCodeValidDate() {
    let key = PHONEVALIDDATE;
    let now = moment();
    let dateStr = now.format(DATE_FORMAT);
    this.set(key, dateStr);
  },
  getPhoneVerifyCodeValidDate() {
    let key = PHONEVALIDDATE;
    let dateStr = this.get(key);
    if (dateStr == null) {
      return null;
    } else {
      return moment(dateStr, DATE_FORMAT);
    }
  },
  setPhoneVerifyCode(verifyCode) {
    let key = PHONEVERIFYCODEKEY;
    let dateKey = PHONEVALIDDATE;
    if (verifyCode == null || verifyCode == undefined) {
      this.set(key, null);
      this.set(dateKey, null);
      return;
    }
    this.setPhoneVerifyCodeValidDate();
    this.set(key, verifyCode);
  },
  getPhoneVerifyCode() {
    let validDate = this.getPhoneVerifyCodeValidDate();
    if (validDate == null) {
      return null;
    }
    let now = moment();
    let value = this.get(PHONEVERIFYCODEKEY);
    if (value == null) {
      return null;
    }

    if (now - validDate <= 60 * 1000) {
      return value;
    } else {
      this.set(PHONEVERIFYCODEKEY, null);
      return null;
    }
  },

}



// WEBPACK FOOTER //
// ./src/js/data-store.js